/**
 * Description:
 * This modal is used to show a warning to the org admin before inviting
 * teammates if they are over limit in FT/TE orgs.
 */

import { useTranslation } from '@thoughtspot/i18n';
import {
    Modal,
    ModalSize,
    ModalType,
} from '@thoughtspot/radiant-react/widgets/modal';
import React, { useState } from 'react';

/**
 * @param userLimit: Max number of users allowed.
 * @param currentUsers: Number of users in org currently
 * @param onDismiss: Function to execute on dismissing the modal
 * @param onConfirm: Function to execute on confirming the modal
 * @returns
 */
export interface UserLimitWarningModalProps {
    onDismiss: () => void;
    onConfirm: () => void;
    userLimit: number;
    currentUsers: number;
}

export const UserLimitWarningModal: React.FC<UserLimitWarningModalProps> = ({
    onDismiss,
    onConfirm,
    userLimit,
    currentUsers,
}) => {
    const { t } = useTranslation();
    const [isModalOpen, setIsModalOpen] = useState(true);
    const bodyContent = t('user_limit_warning', {
        userLimit,
        currentUsers,
    });

    return (
        <Modal
            title={t('user_limit_warning_title')}
            variant={ModalType.Alert}
            size={ModalSize.SMALL}
            isOpen={isModalOpen}
            confirmButton={{
                text: t('continue'),
                onConfirm: () => {
                    onConfirm();
                    setIsModalOpen(false);
                },
            }}
            dismissButton={{
                text: t('Cancel'),
            }}
            onDismiss={() => {
                onDismiss();
                setIsModalOpen(false);
            }}
        >
            <div data-testid="user-limit-warning-body">{bodyContent}</div>
        </Modal>
    );
};
